__webpack_require__.p = "https://moje-fitko.cz/wp-content/plugins/mojefitko/vue/dist/";